import mongoose from 'mongoose'

export const walletSchema = mongoose.Schema({
	name:{
		type:String,
		required:true,
	},
	description:String ,
	owner:{
		type:mongoose.Schema.Types.ObjectId,
		ref:"User"

	}

})
export default mongoose.model("Wallet",walletSchema)
